"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
var _FieldHelperText = _interopRequireDefault(require("../FieldHelperText"));
var _excluded = ["error", "success", "classes", "disabled"],
  _excluded2 = ["error", "success", "classes", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StyledToggle = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      margin: theme.spacing(0, 1),
      fontSize: 'inherit'
    },
    switchBase: {
      color: theme.palette.lightGrey.dark,
      '&$track': {
        color: theme.palette.secondary.main
      },
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    error: {
      color: theme.palette.lightGrey.dark,
      '&$track': {
        color: theme.palette.red.main
      },
      '&$checked': {
        color: theme.palette.red.main
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.red.main
      }
    },
    success: {
      color: theme.palette.lightGrey.dark,
      '&$track': {
        color: theme.palette.green.main
      },
      '&$checked': {
        color: theme.palette.green.main
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.green.main
      }
    },
    checked: {},
    track: {}
  };
})(function (_ref) {
  var error = _ref.error,
    success = _ref.success,
    classes = _ref.classes,
    disabled = _ref.disabled,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Switch["default"], _extends({
    classes: {
      root: classes.root,
      switchBase: (0, _clsx["default"])(classes.switchBase, !disabled && success && classes.success, !disabled && error && classes.error),
      checked: classes.checked,
      track: classes.track
    },
    disabled: disabled
  }, other));
});
var StyledCheckbox = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: 0,
      margin: theme.spacing(0, 1),
      fontSize: 'inherit',
      color: theme.palette.primary.main,
      '&$checked': {
        color: theme.palette.primary.main
      }
    },
    error: {
      color: theme.palette.red.main,
      '&$checked': {
        color: theme.palette.red.main
      }
    },
    success: {
      color: theme.palette.green.main,
      '&$checked': {
        color: theme.palette.green.main
      }
    },
    checked: {}
  };
})(function (_ref2) {
  var error = _ref2.error,
    success = _ref2.success,
    classes = _ref2.classes,
    disabled = _ref2.disabled,
    other = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], _extends({
    classes: {
      root: (0, _clsx["default"])(classes.root, !disabled && success && classes.success, !disabled && error && classes.error),
      checked: classes.checked
    },
    disabled: disabled
  }, other));
});
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    formControlLabel: {
      marginTop: theme.spacing(1),
      fontSize: 'inherit'
    },
    helperTextToggle: {
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(2),
      marginTop: 0
    },
    helperTextCheckbox: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(2),
      marginTop: 0
    }
  };
});
var Control = function Control(props) {
  var handleChange = props.handleChange,
    error = props.error,
    success = props.success,
    options = props.options,
    value = props.value,
    defaultValue = props.defaultValue,
    row = props.row,
    controlType = props.controlType,
    name = props.name,
    disabledForm = props.disabled,
    inputRef = props.inputRef;
  var classes = useStyles();
  var onChange = function onChange(event) {
    var selectedValue = event.target.value;
    var checked = event.target.checked;
    var newValues;
    if (checked) newValues = [].concat(_toConsumableArray(value), [selectedValue]);else {
      newValues = _toConsumableArray(value);
      var index = newValues.indexOf(selectedValue);
      if (index !== -1) newValues.splice(index, 1);
    }
    if (handleChange) handleChange(newValues);
  };
  var ControlComponent = controlType === 'toggle' ? StyledToggle : StyledCheckbox;
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], null, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    ref: inputRef,
    name: name,
    row: row
  }, options && options.map(function (_ref3, k) {
    var optionValue = _ref3.value,
      disabled = _ref3.disabled,
      label = _ref3.label,
      details = _ref3.details;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: optionValue,
      className: classes.controlContainer
    }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
      id: k,
      value: optionValue,
      label: label,
      disabled: disabledForm || disabled,
      checked: value ? value.includes(optionValue) : undefined,
      className: classes.formControlLabel,
      control: /*#__PURE__*/_react["default"].createElement(ControlComponent, {
        error: error,
        success: success,
        onChange: handleChange ? onChange : undefined,
        defaultChecked: defaultValue ? defaultValue.includes(optionValue) : undefined
      })
    }), !!details && /*#__PURE__*/_react["default"].createElement(_FieldHelperText["default"], {
      className: controlType === 'toggle' ? classes.helperTextToggle : classes.helperTextCheckbox
    }, details));
  })));
};
Control.propTypes = {
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  })]),
  name: _propTypes["default"].string,
  success: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  value: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  defaultValue: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  row: _propTypes["default"].bool,
  controlType: _propTypes["default"].string,
  handleChange: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string,
    details: _propTypes["default"].string,
    disabled: _propTypes["default"].bool
  })).isRequired
};
Control.defaultProps = {
  inputRef: undefined,
  defaultValue: undefined,
  value: undefined,
  handleChange: undefined,
  disabled: undefined,
  controlType: undefined,
  name: undefined,
  success: false,
  error: false,
  row: undefined
};
var _default = exports["default"] = (0, _withFormField["default"])({
  messagePosition: 'top'
})(Control);